import React from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import AlarmGrid from '../molecules/Grid/AlarmGrid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  paper: {
    height: '76px',
    width: 'calc(100vw - 16px)',
    color: '#FFFFFF',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'fixed',
    bottom: '0px',
    marginBottom: '4px',
  },
});

const AppHeader: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.paper}>
      <AlarmGrid />
    </div>
  );
};

export default AppHeader;
